

export const AdminMainWrapper = ({ children }) => {

    return (
        <main id="main" className="main">

            <div className="pagetitle">
                <h1 className="use-font">Ново на заявление</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/schadm">Начало</a></li>
                        <li className="breadcrumb-item active">Ново на заявление</li>
                    </ol>
                </nav>
            </div>

            <section className="section dashboard">

                <div className="row">

                    <div className="col-lg-12">
                        {children}
                    </div>

                </div>

            </section>

        </main>
    )
}